import { Routes, Route, Outlet } from "react-router-dom";
import Show from "./Show";
import New from "./New";
import Edit from "./Edit";

function ProjectSurveysMspa(props) {
  const project_id = Number(window.location.href?.split("/")?.[4]);

  return (
    <Routes>
      <Route path="/" element={<Outlet />}>
        <Route index element={<Show {...props} project_id={project_id} />} />
      </Route>
      <Route path="/new" element={<Outlet />}>
        <Route index element={<New {...props} project_id={project_id} />} />
      </Route>
      <Route path="/:id" element={<Outlet />}>
        <Route index element={<Edit {...props} project_id={project_id} />} />
      </Route>
      <Route path="/take" element={<Outlet />}>
        <Route
          index
          element={
            <Show
              {...props}
              project_id={project_id}
              hideCompletedSurveys={true}
            />
          }
        />
      </Route>
    </Routes>
  );
}

export default ProjectSurveysMspa;
